<template>
    <section class="super-user-browser">
        <ul class="nav nav-tabs super-user-tabs mb-3">
            <li class="nav-item" v-for="tab in tabs" :key="tab.key">
                <a
                    class="nav-link"
                    :class="{ active: activeTab === tab.key }"
                    href="#"
                    @click.prevent="activeTab = tab.key"
                >
                    <i :class="tab.icon" class="mr-1"></i> {{ tab.label }}
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <div v-if="activeTab === 'users'">
                <company-users :company-id="companyId"></company-users>
            </div>
            <div v-if="activeTab === 'preview'">
                <entity-browser
                    :company-id="companyId"
                    :is-company-accredited="isCompanyAccredited"
                ></entity-browser>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        companyId: {
            type: [Number, String],
            required: true
        },
        isCompanyAccredited: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeTab: 'preview',
            tabs: [
                { key: 'users', label: 'Users', icon: 'fa fa-users' },
                { key: 'preview', label: 'Preview', icon: 'fa fa-eye' }
            ]
        };
    }
}
</script>
